import classnames from 'classnames'
import React from 'react'
import { useSelector } from 'react-redux'
import { selectAdDataByAdId, selectPageIdForAdConfig } from '../../store/ad/ad.selectors'
import { selectCategorySegmentByCategoryId } from '../../store/poiassets/poiassets.selectors'
import { isEmptyObj } from '../../utils/object'
import DelayComponent from '../utils/DelayComponent'
import { useSelectorWithProps } from '../utils/react-redux'
import { getAdIdByAdName } from './AdConfigService'
import AdLoader from './AdLoader'
import s from './AdMenu.less'

const adName = 'menuthema'

const AdMenu = ({ categoryId }) => {
  const segment = useSelectorWithProps(selectCategorySegmentByCategoryId, { id: categoryId })
  const pageId = useSelector(selectPageIdForAdConfig)
  const adId = getAdIdByAdName(adName, pageId)
  const adData = useSelectorWithProps(selectAdDataByAdId, { adId })
  const { Menuthema } = adData || {}
  const { title, text, linkLabel, imgUrl, linkUrl } = Menuthema || {}
  const categorySelector = () => ({ segment })

  return (
    <DelayComponent key={`delay-adloader-${categoryId}`} delay={200}>
      <AdLoader key={`adloader-${categoryId}`} adName={adName} askData keywordsSelector={categorySelector}>
        <div className={classnames(s.container, isEmptyObj(adData) && s.hidden)}>
          {!isEmptyObj(adData) && (
            <a className={s.linkWrapper} href={linkUrl} target="_blank" rel="nofollow noopener noreferrer">
              <img className={s.logo} src={imgUrl} />

              <div className={s.message}>
                <div className={s.title}>{title}</div>
                {text} <span className={s.label}>{linkLabel}</span>
              </div>
            </a>
          )}
        </div>
      </AdLoader>
    </DelayComponent>
  )
}

export default AdMenu
